import React from "react";
import { AdminSidebar } from "./AdminSidebar";
import { AdminTopNav } from "./AdminTopNav";

interface AdminLayoutProps {
  children: React.ReactNode;
  searchQuery?: string;
  onSearchChange?: (val: string) => void;
  searchPlaceholder?: string;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  searchQuery,
  onSearchChange,
  searchPlaceholder,
}) => {
  return (
    <div className="flex h-screen bg-[#F8FAFC] font-sans overflow-hidden">
      {/* Reusable Sidebar */}
      <AdminSidebar />

      {/* Main Panel Content Container */}
      <div className="flex-1 flex flex-col h-full overflow-hidden">
        {/* Reusable Header Navigation */}
        <AdminTopNav
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          searchPlaceholder={searchPlaceholder}
        />

        {/* Dynamic page contents wrapper */}
        <main className="flex-1 flex flex-col p-8 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
};
